<template>
    <div class="inputContainer" :style="{width: width}">
        <input @focus="$emit('focus')" :value="this.value" :class="{iconPadding: icon}" @input="inputChange" @keyup.enter="$emit('enter')" :disabled="disabled" :required="this.isRequired">
        <span class="label">{{label}}</span>
        <div v-if="icon" class="iconContainer" :class="{leftBorder: iconBorder, pointer: this.$listeners.click}">
            <span class="icon" :class="[icon]"
                  @click="$emit('click')" :style="{color: iconColor, fontSize: iconSize}"></span>
        </div>

    </div>
</template>

<script>
    export default {
        name: "InputFloatLabel",
        data: function () {
            return {
                isRequired: (this.required && (this.value === '' || this.value === null)),
                inputValue : this.value
            };
        },
        computed: {

        },
        props: {
            disabled: Boolean,
            label: String,
            value: String,
            width: String,
            icon: String,
            iconColor: String,
            iconBorder: Boolean,
            iconSize: String,
            required: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onEnter: function (e) {
                if (e.keyCode === 13) {
                    alert('Enter was pressed');
                } else if (e.keyCode === 50) {
                    alert('@ was pressed');
                }
            },
            inputChange(event){
                this.inputValue = event.target.value;
                if(this.inputValue === '' && this.required){
                    this.isRequired = true;
                }else{
                    this.isRequired = false;
                }
                this.$emit('input', this.inputValue);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .inputContainer {
        position: relative;
    }

    input {
        padding: 1.1em 0.5em 0.5em 0.5em;
        width: 100%;
        font-size: 15px;
        border: 1px solid $grey !important;
    }

    input:disabled {
        background: transparent;
        border-color: transparent;
        border-bottom: 1px solid #ccc;
        color: black;
    }

    input:focus ~ .label, input:disabled ~ .label,
    input:disabled:not(:focus):valid ~ .label, input:not(:focus):valid ~ .label
    {
        top: 6px;
        bottom: 10px;
        left: 9px;
        font-size: 11px;
        opacity: 1;
    }

    .iconPadding {
        padding-right: 3em;
    }

    .label {
        position: absolute;
        left: 10px;
        top: 16px;
        font-size: 1em;
        color: $darkGrey;
        pointer-events: none;
        transition: 0.2s ease all;
        opacity: 0.5;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
    }

    .leftBorder {
        border-left: 1px solid $grey;
    }

    .iconContainer {
        position: absolute;
        top: 0;
        right: 0;
        border-left: 1px solid $grey;
        width: 47px;
        height: 100%;
    }

    .icon {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        right: 0;
        font-size: 2.1em;
    }

    .icon:hover {
        color: $pink;
    }

    .icon:before {
        display: flex;
    }

    .pointer{
        cursor: pointer;
    }

    :required {
        border: 2px solid $pink !important;
    }
</style>